import withProps from 'recompose/withProps';
import data from './data.json';

export default withProps(({ appOptions })=>{
	appOptions = appOptions || [];
	data.map((rest: any)=>{
		appOptions.push({ ...rest, category: 'google' })
	})
	return ({ appOptions })
})